import { render, staticRenderFns } from "./GroupKeyCreate.vue?vue&type=template&id=5c23f3b6&"
import script from "./GroupKeyCreate.vue?vue&type=script&lang=js&"
export * from "./GroupKeyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports